"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var React = __importStar(require("react"));
var ApolloReactComponents = __importStar(require("@apollo/react-components"));
var ApolloReactHoc = __importStar(require("@apollo/react-hoc"));
var BatchWithdrawalStatus;
(function (BatchWithdrawalStatus) {
    BatchWithdrawalStatus["Active"] = "active";
    BatchWithdrawalStatus["Processing"] = "processing";
    BatchWithdrawalStatus["Confirmed"] = "confirmed";
})(BatchWithdrawalStatus = exports.BatchWithdrawalStatus || (exports.BatchWithdrawalStatus = {}));
var Frequency;
(function (Frequency) {
    Frequency["Daily"] = "daily";
    Frequency["Hourly"] = "hourly";
    Frequency["HalfHour"] = "half_hour";
    Frequency["QuarterHour"] = "quarter_hour";
    Frequency["Minutely"] = "minutely";
})(Frequency = exports.Frequency || (exports.Frequency = {}));
var Logic;
(function (Logic) {
    Logic["Xyo"] = "xyo";
    Logic["Generic"] = "generic";
})(Logic = exports.Logic || (exports.Logic = {}));
var RedeemType;
(function (RedeemType) {
    RedeemType["Url"] = "url";
    RedeemType["Withdraw"] = "withdraw";
    RedeemType["Qrcode"] = "qrcode";
})(RedeemType = exports.RedeemType || (exports.RedeemType = {}));
var RewardType;
(function (RewardType) {
    RewardType["Url"] = "url";
    RewardType["Tier"] = "tier";
    RewardType["Qrcode"] = "qrcode";
})(RewardType = exports.RewardType || (exports.RewardType = {}));
var Unit;
(function (Unit) {
    Unit["Noether"] = "noether";
    Unit["Wei"] = "wei";
    Unit["Kwei"] = "kwei";
    Unit["Babbage"] = "babbage";
    Unit["Femtoether"] = "femtoether";
    Unit["Mwei"] = "mwei";
    Unit["Lovelace"] = "lovelace";
    Unit["Picoether"] = "picoether";
    Unit["Gwei"] = "gwei";
    Unit["Shannon"] = "shannon";
    Unit["Nanoether"] = "nanoether";
    Unit["Nano"] = "nano";
    Unit["Szabo"] = "szabo";
    Unit["Microether"] = "microether";
    Unit["Micro"] = "micro";
    Unit["Finney"] = "finney";
    Unit["Milliether"] = "milliether";
    Unit["Milli"] = "milli";
    Unit["Ether"] = "ether";
    Unit["Kether"] = "kether";
    Unit["Grand"] = "grand";
    Unit["Mether"] = "mether";
    Unit["Gether"] = "gether";
    Unit["Tether"] = "tether";
})(Unit = exports.Unit || (exports.Unit = {}));
exports.DropFragmentDoc = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment Drop on Drop {\n  id\n  dropUid\n  variant\n  dropTime\n  dropYYYYMMDD\n  quadkey\n  fullQuadkey\n  latitude\n  longitude\n  lonlat\n  email\n  asset\n  amount\n  fee\n  message\n  claimed\n  collected\n  receiptDelivered\n  claimedTime\n  claimedUid\n  collectedTime\n  receiptMessage\n  receiptTime\n  link\n  linkClicked\n  linkClickedTime\n  converted\n  conversionTime\n  advancedId\n  buttonText\n  condition {\n    advancedId\n    variant\n    collected\n  }\n}\n    "], ["\n    fragment Drop on Drop {\n  id\n  dropUid\n  variant\n  dropTime\n  dropYYYYMMDD\n  quadkey\n  fullQuadkey\n  latitude\n  longitude\n  lonlat\n  email\n  asset\n  amount\n  fee\n  message\n  claimed\n  collected\n  receiptDelivered\n  claimedTime\n  claimedUid\n  collectedTime\n  receiptMessage\n  receiptTime\n  link\n  linkClicked\n  linkClickedTime\n  converted\n  conversionTime\n  advancedId\n  buttonText\n  condition {\n    advancedId\n    variant\n    collected\n  }\n}\n    "])));
exports.CreateGeoDropsDocument = graphql_tag_1.default(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    mutation CreateGeoDrops($input: DropInput!, $quantity: Int, $uids: [String], $from: String) {\n  createDrops(input: $input, quantity: $quantity, uids: $uids, from: $from) {\n    ...Drop\n  }\n}\n    ", ""], ["\n    mutation CreateGeoDrops($input: DropInput!, $quantity: Int, $uids: [String], $from: String) {\n  createDrops(input: $input, quantity: $quantity, uids: $uids, from: $from) {\n    ...Drop\n  }\n}\n    ", ""])), exports.DropFragmentDoc);
exports.CreateGeoDropsComponent = function (props) { return (React.createElement(ApolloReactComponents.Mutation, __assign({ mutation: exports.CreateGeoDropsDocument }, props))); };
function withCreateGeoDrops(operationOptions) {
    return ApolloReactHoc.withMutation(exports.CreateGeoDropsDocument, __assign({ alias: 'createGeoDrops' }, operationOptions));
}
exports.withCreateGeoDrops = withCreateGeoDrops;
;
var templateObject_1, templateObject_2;
//# sourceMappingURL=graphql.generated.js.map